import UIManager from "../../Shared/UIManager";
import NetworkLogic from "../../Shared/NetworkLogic";
import Utils from "../../Shared/Utils";
import HallUI from "../HallUI";
import FilterGameType from "../FilterGameType";
import Tool from "./Tool";
import disallowMultiple = cc._decorator.disallowMultiple;
import Player from "../../Models/Player";
import RemoteSprite from "../../Common/RemoteSprite";
import AudioManager from "../../Shared/AudioManager";
import {Global} from "../../Shared/Global";
import GameList from "../../Models/GameList";
import XiMaBiLi from "./XiMaBiLi";

const {ccclass, property} = cc._decorator;

@ccclass
export default class ZiZhuXiMa extends cc.Component {
    @property(XiMaBiLi)
    xiMaBiLi: XiMaBiLi = null;
    @property(cc.Node)
    iconGold: cc.Node = null;
    @property(RemoteSprite)
    rspHead:RemoteSprite = null;
    @property(cc.Label)
    labVipLevel: cc.Label = null;//洗码金额
    @property(cc.Node)
    nodeContent: cc.Node = null;
    @property(cc.Node)
    playerBalanceUI: cc.Node = null;
    @property([cc.Label])
    arrNameLab: cc.Label[] = [];//
    @property([cc.Label])
    arrTotalStreamLab: cc.Label[] = [];//打码总量
    @property([cc.Label])
    arrRatLab: cc.Label[] = [];//最高洗码比例
    @property(cc.Label)
    arrMoneyLab: cc.Label[] = [];//洗码金额
    @property([cc.Button])
    arrGoBtn: cc.Button[] = [];//去完成
    @property([cc.Button])
    arrLingquBtn: cc.Button[] = [];//领取
    @property(cc.Button)
    btnQuickPick: cc.Button = null;//领取
    @property(cc.Label)
    labTotalMoney: cc.Label = null;//洗码总金额
    private  ttMoney : number = 0;//洗码总额
    bPlayAction = false;
    infoDtos = null;

    onLoad(): void {
        this.nodeContent.active  = true;
        this.btnQuickPick.interactable = false;
    }

    onEnable () {
        // if (this.bPlayAction)
            Utils.actionShowContent(this.nodeContent);

    }

    start(): void {

       
        Player.getPy("head") && (this.rspHead.url = Player.getPy("head"));

        //请求数据返回
        UIManager.showLoadingUI();
        NetworkLogic.ximaInfo(function (data) {
            UIManager.hideLoadingUI();
            console.log("rich=== Info:",data);
            let infoDtos = data.washCodeTypeInfoDtos;
            if (!infoDtos) return;
            this.xiMaBiLi.infoDtos = infoDtos;
            for (let i = 0;i < infoDtos.length;i++){
                this.arrNameLab[i].string = infoDtos[i].gameTypeName;
                let gameInfoLists = infoDtos[i].gameInfoLists;
                let money = 0;
                let totalmoney = 0;
                let prop = 0;

                for (let j = 0;j < gameInfoLists.length;j++){
                    money += gameInfoLists[j].washCodeMoney;
                    totalmoney += gameInfoLists[j].gameWashCodeDml;
                    prop = prop >= gameInfoLists[j].washCodeProportion ? prop : gameInfoLists[j].washCodeProportion;
                }
                this.ttMoney += money;
                this.arrTotalStreamLab[i].string = totalmoney.toFixed(2);
                this.arrRatLab[i].string = prop.toFixed(2)+"%";
                this.arrMoneyLab[i].string = money.toFixed(2);
                this.arrGoBtn[i].node.active = true;
                this.arrLingquBtn[i].node.active = false;
                if (this.arrGoBtn[i].node.active){
                    this.arrGoBtn[i].clickEvents[0].customEventData = infoDtos[i].gameTypeId;
                }
            }
            this.labTotalMoney.string = "¥ " + this.ttMoney.toFixed(2);
            this.btnQuickPick.interactable = ( this.ttMoney > 0 );

            this.nodeContent.active = true;
            Utils.actionShowContent(this.nodeContent);
            this.bPlayAction = true;
        }.bind(this),function () {
            console.log("rich=== ximaZZXM请求失败")
        })


        NetworkLogic.vipShow(function (data) {
            cc.log("====vip data:",data);
            for (let i = 0 ;i < data.userVipSettings.length;i++){
                let item = data.userVipSettings[i];
                if (item.id === data.vipId){
                    this.labVipLevel.string = item.userVip;
                }
            }
            //data.userVipSettings[data.vipId].
            //this.labVipLevel.string = data.vipId < 1 ? 1 : data.vipId;
        }.bind(this),function () {
            console.log("vip获取失败")
        })
    }
    onBtnClick(event,param){
        AudioManager.playSound("button");

        let num = parseInt(param);
        if (num){
            Utils.showGameNode();
            let filtercontent = cc.find("Canvas/gameNode/gameTypes/node/view/content")
            let toggleItems = filtercontent.getComponent(cc.ToggleContainer).toggleItems;
            let name = Tool.getName(num);
            for (let i = 0;i < toggleItems.length;i++){
                if (toggleItems[i].node.name === name){
                    toggleItems[i].check();
                    break;
                }
            }
            this.node.parent.parent.destroy();
        }
        if(param === "lq"){// 领取
            UIManager.showLoadingUI();
            NetworkLogic.ximaMaualWashCode(function () {
                UIManager.hideLoadingUI();
                cc.director.emit(Global.UserEvent.OpenBaoxiang,this.labTotalMoney.string);
                for (let i = 0;i < this.arrMoneyLab.length;i++){
                    this.arrMoneyLab[i].string = 0;
                    this.arrTotalStreamLab[i].string = 0;
                    this.arrLingquBtn[i].node.active = false;
                    this.arrGoBtn[i].node.active = true;
                }
                this.labTotalMoney.string = 0;
                this.btnQuickPick.interactable = false;
                this.playerBalanceUI.getComponent("PlayerBalanceUI").pullMoney(0);
            }.bind(this),function () {
                console.log("====手动洗码出错")
            }.bind(this))
        }
        else if(param === "vip"){
            console.log("===点击自助洗码");
            let canvas = cc.director.getScene().getChildByName("Canvas");
            let hallUI = canvas.getChildByName("gameNode").getComponent("HallUI") as HallUI;
            if (hallUI){
                let vip = hallUI.pfbVip;
                cc.instantiate(vip).parent = canvas;
            }
        }
    }

    getGoldPos(){
        let outPos = this.iconGold.parent.convertToWorldSpaceAR(this.iconGold.getPosition());
        let nodepos = this.node.parent.convertToNodeSpaceAR(outPos);
        return nodepos;
    }
}
